.Viewer {
  height: 100%;

  border-radius: inherit;

  &_FullHeight {
    height: 100%;
  }

  transform: scale(1);
}
